
export const DIR_FILTER_BASIC_FIELDS = {
  // === Boolean Type Fields===
  prospect_id: {
    label: "Matching Type",
    type: "boolean",
    operators: ["is_null", "is_not_null"],
    fieldSettings: {
      // ES field whose presence/absence maps to the true/false options. Any boolean field
      // can opt into presence-driven options just by setting this — no backend change needed.
      presenceField: "prospect_id",
      listValues: [
        { term: "matched", label: "Matched", value: true },
        { term: "unmatched", label: "Unmatched", value: false }
      ]
    },
    renderBuilder: "BooleanTypeBuilder"
  },
  // === Basic Identity Fields ===
  full_name: {
    label: "Name",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder",
    elasticSearchField: "full_name"
  },
  headline: {
    label: "Headline",
    type: "text",
    valueSources: ["value"],
    operators: ["like", "starts_with", "has_no_value"],
    defaultOperator: "like",
    preferWidgets: ["likeTextWidget", "startsWithText"],
    widgets: {
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"], defaultOperator: "like" },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  industry: {
    label: "Industry",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  new_current_company: {
    label: "Current Company",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  new_current_designation: {
    label: "Current Title",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    fieldSettings: {
      allowCustomValues: true,
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  current_start_date: {
    label: "Current Start Date",
    type: "date",
    operators: ["equal", "greater_or_equal", "less_or_equal", "between", "empty_date"],
    operatorLabels: {
      equal: { short: "is", long: "is" },
      greater_or_equal: { short: "is after", long: "is after" },
      less_or_equal: { short: "is before", long: "is before" },
      between: { short: "is between", long: "is between" },
      empty_date: {short: "is empty", long: "is empty"}
    },
    preferWidgets: ["monthYearToRangeWidget"],
    widgets: {
      monthYearToRangeWidget: { operators: ["greater_or_equal", "less_or_equal"] },
      hasNoDateWidget: { operators: ["empty_date"] }
    },
    defaultOperator: "equal",
    renderBuilder: "DateTypeBuilder"
  },
  location: {
    label: "Location",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  seniority_level: {
    label: "Seniority Level",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals"],
    defaultOperator: "multiselect_equals",
    widgets: {
      multiselect: {
        operators: ["multiselect_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      }
    },
    fieldSettings: {
      listValues: [
        { value: "in training", title: "In Training" },
        { value: "entry level", title: "Entry Level" },
        { value: "senior level", title: "Senior Level" },
        { value: "vp", title: "VP" },
        { value: "director", title: "Director" },
        { value: "cxo", title: "CXO" },
        { value: "partner", title: "Partner" }
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  current_institute: {
    label: "Education",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  course: {
    label: "Degree",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  branch: {
    label: "Major",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  education_start_date: {
    label: "Education Start Date",
    shortLabel: "Edu Start Date",
    type: "date",
    operators: ["equal", "greater_or_equal", "less_or_equal", "between", "empty_date"],
    operatorLabels: {
      equal: { short: "is", long: "is" },
      greater_or_equal: { short: "is after", long: "is after" },
      less_or_equal: { short: "is before", long: "is before" },
      between: { short: "is between", long: "is between" },
      empty_date: {short: "is empty", long: "is empty"}
    },
    preferWidgets: ["monthYearToRangeWidget"],
    widgets: {
      monthYearToRangeWidget: { operators: ["greater_or_equal", "less_or_equal"] },
      hasNoDateWidget: { operators: ["empty_date"] }
    },
    defaultOperator: "equal",
    renderBuilder: "DateTypeBuilder"
  },
  education_end_date: {
    label: "Education End Date",
    shortLabel: "Edu End Date",
    type: "date",
    operators: ["equal", "greater_or_equal", "less_or_equal", "between", "empty_date"],
    operatorLabels: {
      equal: { short: "is", long: "is" },
      greater_or_equal: { short: "is after", long: "is after" },
      less_or_equal: { short: "is before", long: "is before" },
      between: { short: "is between", long: "is between" },
      empty_date: {short: "is empty", long: "is empty"}
    },
    preferWidgets: ["monthYearToRangeWidget"],
    widgets: {
      monthYearToRangeWidget: { operators: ["greater_or_equal", "less_or_equal"] },
      hasNoDateWidget: { operators: ["empty_date"] }
    },
    defaultOperator: "equal",
    renderBuilder: "DateTypeBuilder"
  },
  city: {
    label: "City",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  state: {
    label: "State",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  country: {
    label: "Country/Region",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  new_years_of_exp: {
    label: "Years of Experience",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals_range"],
    defaultOperator: "multiselect_equals_range",
    preferWidgets: ["experienceWidget"],
    widgets: {
      experienceWidget: { operators: ["multiselect_equals_range"] }
    },
    fieldSettings: {
      presenceType: "range",
      listValues: [
        { value: "less_than_a_year", title: "Less than a year" },
        { value: "1_to_3_years", title: "1 to 3 years" },
        { value: "3_to_5_years", title: "3 to 5 years" },
        { value: "5_to_10_years", title: "5 to 10 years" },
        { value: "more_than_10_years", title: "More than 10 years" }
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  new_years_of_company_exp: {
    label: "Years in Current Company",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals_range"],
    defaultOperator: "multiselect_equals_range",
    preferWidgets: ["experienceWidget"],
    widgets: {
      experienceWidget: { operators: ["multiselect_equals_range"] }
    },
    fieldSettings: {
      presenceType: "range",
      listValues: [
        { value: "less_than_a_year", title: "Less than a year" },
        { value: "1_to_3_years", title: "1 to 3 years" },
        { value: "3_to_5_years", title: "3 to 5 years" },
        { value: "5_to_10_years", title: "5 to 10 years" },
        { value: "more_than_10_years", title: "More than 10 years" }
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  new_years_of_designation_exp: {
    label: "Years in Current Role",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals_range"],
    defaultOperator: "multiselect_equals_range",
    preferWidgets: ["experienceWidget"],
    widgets: {
      experienceWidget: { operators: ["multiselect_equals_range"] }
    },
    fieldSettings: {
      presenceType: "range",
      listValues: [
        { value: "less_than_a_year", title: "Less than a year" },
        { value: "1_to_3_years", title: "1 to 3 years" },
        { value: "3_to_5_years", title: "3 to 5 years" },
        { value: "5_to_10_years", title: "5 to 10 years" },
        { value: "more_than_10_years", title: "More than 10 years" }
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  past_companies: {
    label: "Past Companies",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  institute: {
    label: "All Educations",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  company_size_range: {
    label: "Company Size",
    type: "multiselect",
    operators: ["multiselect_equals"],
    defaultOperator: "multiselect_equals",
    valueSources: ["value"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      }
    },
    fieldSettings: {
      listValues: [
        { value: "myself only", title: "Self Employed" },
        { value: "2-10", title: "2-10" },
        { value: "11-50", title: "11-50" },
        { value: "51-200", title: "51-200" },
        { value: "201-500", title: "201-500" },
        { value: "501-1000", title: "501-1000" },
        { value: "1001-5000", title: "1001-5000" },
        { value: "5001-10000", title: "5001-10,000" },
        { value: "10001+", title: "10,001+" },
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  company_type: {
    label: "Company Type",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals"],
    defaultOperator: "multiselect_equals",
    widgets: {
      multiselect: {
        operators: ["multiselect_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      }
    },
    fieldSettings: {
      listValues: [
        { value: "public company", title: "Public Company" },
        { value: "privately held", title: "Privately Held" },
        { value: "nonprofit", title: "Nonprofit" },
        { value: "educational institution", title: "Educational Institution" },
        { value: "partnership", title: "Partnership" },
        { value: "self-employed", title: "Self Employed" },
        { value: "sole proprietorship", title: "Self Owned" },
        { value: "government agency", title: "Government Agency" }
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  company_industry: {
    label: "Company Industry",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  company_revenue: {
    label: "Company Revenue",
    type: "multiselect",
    operators: ["multiselect_equals"],
    defaultOperator: "multiselect_equals",
    valueSources: ["value"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      }
    },
    fieldSettings: {
      listValues: [
        { value: "Less than $1M", title: "Less than $1M" },
        { value: "$1M - $2.5M", title: "$1M - $2.5M" },
        { value: "$2.5M - $5M", title: "$2.5M - $5M" },
        { value: "$5M - $10M", title: "$5M - $10M" },
        { value: "$10M - $20M", title: "$10M - $20M" },
        { value: "$20M - $50M", title: "$20M - $50M" },
        { value: "$50M - $100M", title: "$50M - $100M" },
        { value: "$100M - $500M", title: "$100M - $500M" },
        { value: "$500M - $1B", title: "$500M - $1B" },
        { value: "$1B - $5B", title: "$1B - $5B" },
        { value: "$5B - $10B", title: "$5B - $10B" },
        { value: "More than $10B", title: "More than $10B" },
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  company_location: {
    label: "Company Location",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  volunteering_role: {
    label: "Volunteering Roles",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  volunteering_type: {
    label: "Volunteering Types",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  skill: {
    label: "Skills",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals", "multiselect_not_equals", "like", "starts_with", "has_no_value"],
    defaultOperator: "multiselect_equals",
    preferWidgets: ["multiselect", "likeTextWidget", "startsWithText"],
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals"],
        defaultOperator: "multiselect_equals",
        multi: true
      },
      startsWithText: { operators: ["starts_with"] },
      likeTextWidget: { operators: ["like"] },
      hasNoValueWidget: { operators: ["has_no_value"] }
    },
    renderBuilder: "DirectoryDropdownBuilder"
  },
  job_change: {
    label: "Recent Job Changes",
    type: "multiselect",
    valueSources: ["value"],
    operators: ["multiselect_equals_range"],
    defaultOperator: "multiselect_equals_range",
    preferWidgets: ["jobChangeWidget"],
    widgets: {
      jobChangeWidget: { operators: ["multiselect_equals_range"] }
    },
    fieldSettings: {
      presenceType: "range",
      listValues: [
        { value: "employment", title: "Employment" },
        { value: "designation", title: "Designation" }
      ]
    },
    renderBuilder: "CheckboxTypeBuilder"
  },
  recent_job_changed_at: {
    label: "Last Job Changed At",
    access: 'list_last_synced_at',
    type: "date",
    operators: ["equal", "greater_or_equal", "less_or_equal", "between", "empty_date"],
    operatorLabels: {
      equal: { short: "is", long: "is" },
      greater_or_equal: { short: "is after", long: "is after" },
      less_or_equal: { short: "is before", long: "is before" },
      between: { short: "is between", long: "is between" },
      empty_date: {short: "is empty", long: "is empty"}
    },
    preferWidgets: ["monthYearToRangeWidget"],
    widgets: {
      monthYearToRangeWidget: { operators: ["greater_or_equal", "less_or_equal"] },
      hasNoDateWidget: { operators: ["empty_date"] }
    },
    defaultOperator: "equal",
    renderBuilder: "DateTypeBuilder"
  },
};

const DEFAULT_DIR_COLUMNS = ['full_name', 'new_current_designation', 'location', 'new_current_company', 'industry'];
const EXCLUDE_DIR_COLUMNS = ['prospect_id', 'job_change', 'recent_job_changed_at'];
const OTHER_DIR_COLUMNS = Object.keys(DIR_FILTER_BASIC_FIELDS).filter(
  key => ![...DEFAULT_DIR_COLUMNS, ...EXCLUDE_DIR_COLUMNS].includes(key)
);

const SUPER_MEMBER_DIR_COLUMNS = {
  recent_job_changed_at: { ...DIR_FILTER_BASIC_FIELDS.recent_job_changed_at, style: { minWidth: "240px", width: '20%' }, access:'list_last_synced_at', columnFilterEnabled: true, display: true},
  last_synced_at: { label: "Last Synced At", style: { minWidth: "240px", width: '20%' }, access:'list_last_synced_at', columnFilterEnabled: false, display: true, type: 'date'},
  view_and_fetch_emails: { label: "Emails", style: { minWidth: "240px", width: '20%' }, access:'generate_possible_email', columnFilterEnabled: false, display: true, type: 'button'},
}

export const initialDirTableColumns = {
  full_name: { ...DIR_FILTER_BASIC_FIELDS.full_name, style: { minWidth: "260px", width: '20%' }, access: '', columnFilterEnabled: true, display: true, search_enabled: true, dropDownEnabled: true, swapEnabled: false, sortingEnabled: true, type: 'text', is_fixed: true },
  new_current_designation: { ...DIR_FILTER_BASIC_FIELDS.new_current_designation, style: { minWidth: "260px", width: '20%' }, access: '', columnFilterEnabled: true, display: true, search_enabled: false, dropDownEnabled: true, swapEnabled: true, sortingEnabled: true, type: 'text', is_fixed: false },
  location: { ...DIR_FILTER_BASIC_FIELDS.location, style: { minWidth: "240px", width: '20%' }, access: '', columnFilterEnabled: true, display: true, search_enabled: false, dropDownEnabled: true, swapEnabled: true, sortingEnabled: true, type: 'text', is_fixed: false },
  new_current_company: { ...DIR_FILTER_BASIC_FIELDS.new_current_company, style: { minWidth: "240px", width: '20%' }, access: '', columnFilterEnabled: true, display: true, search_enabled: false, dropDownEnabled: true, swapEnabled: true, sortingEnabled: true, type: 'text', is_fixed: false },
  industry: { ...DIR_FILTER_BASIC_FIELDS.industry, style: { minWidth: "240px", width: '20%' }, access: '', columnFilterEnabled: true, display: true, search_enabled: false, dropDownEnabled: true, swapEnabled: true, sortingEnabled: true, type: 'text', is_fixed: false },
  ...SUPER_MEMBER_DIR_COLUMNS,
  ...OTHER_DIR_COLUMNS.reduce((acc, key) => {
    acc[key] = {
      ...DIR_FILTER_BASIC_FIELDS[key],
      style: { minWidth: "260px", width: '20%' },
      access: '',
      columnFilterEnabled: true,
      display: false,
      search_enabled: false,
      dropDownEnabled: true,
      swapEnabled: true,
      sortingEnabled: true,
      type: 'text',
      is_fixed: false
    };
    return acc;
  }, {})
};

export const fmt = (value) => (`now-${value}M/M`);
// Keep in sync with backend FilterBandRanges (filter_band_ranges.rb) — presence aggs + saved-report parsing mirror these ranges.
export const bandToEsRange = (field_key, band) => {
  switch (band) {
    case 'less_than_a_year':
      return { [field_key]: { gte: fmt('12') } };

    case '1_to_3_years':
      return { [field_key]: { gte: fmt('36'), lt: fmt('12') } };

    case '3_to_5_years':
      return { [field_key]: { gte: fmt('60'), lt: fmt('36') } };

    case '5_to_10_years':
      return { [field_key]: { gte: fmt('120'), lt: fmt('60') } };

    case 'more_than_10_years':
      return { [field_key]: { lt: fmt('120') } };

    default:
      return null;
  }
}

